import { z } from "zod/v4";
import { baseDESchema, documentoAsociadoSchema, addPaymentValidationWithCondicionRequired, addDocumentoAsociadoValidation, pagoSchema } from "./base-de-schema";

//Schema para Autofactura (iTiDE = 4)
// Vendedor = Contribuyente que no puede facturar
export const autofacturaFormSchema = addDocumentoAsociadoValidation(
    addPaymentValidationWithCondicionRequired(
        z.object({
            ...baseDESchema.shape,
            ...documentoAsociadoSchema.shape,
            pagos: z.array(pagoSchema).optional().default([{ tipoPago: "efectivo", monto: 0 }]),
            vendedorId: z.string().optional().default(""), // Opcional porque puede venir de DNIT sin ID
            tipoDocumentoAsociado: z.enum(["1", "2", "3"]).default("3"), // Default Constancia autofactura
        })
    ),
    false,
    true // Exigir numeroResolucionCF cuando el Emisor tiene Tipo de Transacción = Venta de crédito fiscal
);

export type AutofacturaFormData = z.infer<typeof autofacturaFormSchema>;
